export const profile = {
  name: "Muhammad Risang Radityatama",
  title: "Computer Engineering Student",
  tagline: "Building scalable solutions at the intersection of hardware and software.",
  email: "m.risang25@gmail.com",
  phone: "+6281331928236",
  github: "https://github.com/rxceed",
  linkedin: "https://linkedin.com/in/muhammad-risang-radityatama",
  location: "Surabaya, Indonesia",
  bio: "A Computer Engineering undergraduate at Institut Teknologi Sepuluh Nopember with strong expertise in embedded systems, IoT, backend development, and deep learning. Experienced in building scalable and reliable solutions that integrate hardware and software. Possesses strong analytical thinking, problem-solving skills, and hands-on experience in real-world engineering projects. Complemented by leadership and mentorship experience as a Laboratory Assistant in the Robotics lab, alongside a proven track record of developing automated backend systems for large-scale technology events.",
};
